document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".Banner_Slider");

  if (!slider) return;

  const prevArrow = slider.parentElement.querySelector(".prev");
  const nextArrow = slider.parentElement.querySelector(".next");
  const pagination = slider.parentElement.querySelector(".swiper-pagination");

  const swiper = new Swiper(".Banner_Slider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    direction: "horizontal",
    grabCursor: true,
    speed: 1000,
    parallax: true,
    navigation: {
      nextEl: nextArrow,
      prevEl: prevArrow,
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
    // autoplay: {
    //   delay:5000,
    //   disableOnInteraction: false,
    // },
  });
});
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Products__lists");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.2,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 2.2,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 2.7,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
